<template>
  <div class="theMore">
    <home-nav-bar title="常用工具" />
    <div class="page-content wh-flex-between">
      <div
        v-for="(item, index) in btnList"
        :key="index"
        class="tool-btn-item"
        @click="$router.push({ name: item.to })"
      >
        <van-image
          :src="item.src"
        />
      </div>
    </div>
  </div>
</template>

<script>
import HomeNavBar from '@/views/layout/components/HomeNavBar'
export default {
  name: 'Index',
  components: { HomeNavBar },
  data() {
    return {
      btnList: [
        {
          src: require('@/assets/images/more/bookkeep.png'),
          name: '记账本',
          id: 1,
          to: 'TallyBook'
        },
        {
          src: require('@/assets/images/more/use.png'),
          name: '用药兑水计算',
          id: 2,
          to: 'PotionCalculation'
        },
        // {
        //   src: require('./images/weather.png'),
        //   name: '一周天气预报',
        //   id: 3,
        //   to: {
        //     name: ''
        //   }
        // },
        {
          src: require('@/assets/images/more/search.png'),
          name: '查农资',
          id: 4,
          to: 'ToolAgriculture'
        },
        {
          src: require('@/assets/images/more/forbid.png'),
          name: '禁用农药清单',
          id: 5,
          to: 'BanFertilizer'
        },
        {
          src: require('@/assets/images/more/Limite.png'),
          name: '限用农药清单',
          id: 6,
          to: 'LimitFertilizer'
        },
        {
          src: require('@/assets/images/more/cure.png'),
          name: '病虫草害防治',
          id: 7,
          to: 'DiseasePest'
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.theMore{
  .page-content{
    flex-wrap: wrap;
    .tool-btn-item{
      width: 50%;
    }
  }
}
</style>
